export default function initHoverAnimations() {
    const offsetIncrement = 0.01; // Transition offset increment in seconds
    const menuItems = document.querySelectorAll('nav.header__nav .header__nav__item');

    if (menuItems.length == 0) return;

    menuItems.forEach((element) => {
        if (element.closest('li').classList.contains('active')) return;

        const text = element.textContent;
        element.innerHTML = '';

        // Create wrapper span for overflow
        const wrapper = document.createElement('span');

        [...text].forEach((char, index) => {
            const span = document.createElement('span');
            span.textContent = char;
            span.style.transitionDelay = `${index * offsetIncrement}s`;

            // Handle spaces explicitly
            if (char === ' ') {
                span.style.whiteSpace = 'pre';
            }

            wrapper.appendChild(span);
        });

        element.appendChild(wrapper);
    });

}